import { toast } from 'react-toastify';

export const toastNotification = (status, content, options = {}) => {
  const { title } = options;
  
  const message = title ? (
    <div>
      <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>{title}</div>
      <div style={{ fontSize: '0.9em' }}>{content}</div>
    </div>
  ) : content;

  const showToast = () =>
    toast(message, {
      type: status,
      autoClose: status === 'error' ? 8000 : 5000, // Longer display for errors
      ...options
    });

  return showToast();
};
